import { useEffect, useState } from "react";
import { ArrowDownLeft, ArrowUpRight, Wallet } from "lucide-react";
import { fetchUserTransactions } from "../../services/api";
import { ArrowUp, ArrowDown } from "phosphor-react";

const formatAmount = (value) => {
  const n = Number(value);
  if (Number.isNaN(n)) return "0.00";
  return n.toFixed(2);
};

const TransactionHistory = ({ userId }) => {
  const [transactions, setTransactions] = useState({});
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const loadTransactions = async () => {
      try {
        const token = localStorage.getItem("adminToken");
        const data = await fetchUserTransactions(
          userId || localStorage.getItem("UserId"),
          token
        );
        setTransactions(data || {});
      } catch (error) {
        console.error(error);
        setErrorMsg(error.message || "Failed to load transactions");
      } finally {
        setLoading(false);
      }
    };
    loadTransactions();
  }, [userId]);

  if (loading)
    return <p className="text-center text-secondary">Loading transactions...</p>;

  if (errorMsg)
    return <p className="text-center text-danger">{errorMsg}</p>;

  const months = Object.entries(transactions);

  const { credit: totalCredit, debit: totalDebit } = months.reduce(
    (acc, [, data]) => {
      acc.credit += Number(data.total_credit) || 0;
      acc.debit += Number(data.total_debit) || 0;
      return acc;
    },
    { credit: 0, debit: 0 }
  );
  const balance = totalCredit - totalDebit;

  return (
    <div>
      {/* <div className="d-flex align-itesms-center gap-4 flex-md-row flex-column">
        <div className="card higlight-card flex-grow-1">
          <div className="card-body">
            <div className="dash-card-icon"><Wallet /></div>
              <div className="dash-card-text">
                <h5 className="card-title text-muted mb-2">Balance</h5>
                <p
                  className={`card-text fw-semibold ${
                    balance >= 0 ? "text-success" : "text-danger"
                  }`}
                >
                  ₹{formatAmount(balance)}
                </p>
              </div>
          </div>
        </div>
        <div className="card higlight-card flex-grow-1">
          <div className="card-body">
            <div className="dash-card-icon"><ArrowDownLeft /></div>
            <div className="dash-card-text">
              <h5 className="card-title text-muted mb-2">Credit</h5>
              <p className="card-text">₹{formatAmount(totalCredit)}</p>
            </div>
          </div>
        </div>
        <div className="card higlight-card flex-grow-1">
          <div class="card-body">
            <div className="dash-card-icon"><ArrowUpRight /></div>
            <div className="dash-card-text">
              <h5 className="card-title text-muted mb-2">Debit</h5>
              <p className="card-text">₹{formatAmount(totalDebit)}</p>
            </div>
          </div>
        </div>
      </div> */}
      <div className="transaction-history card shadow-sm border-0 mt-4 mx-auto theme-card-white">
          <h4 className="fw-semibold theme-text-black pb-1 text-center">
            Transaction History
          </h4>
          <p class="text-muted text-sm mb-4 theme-text-color text-center">Enter your password to view your balance.</p>
          {months.length === 0 ? (
            <p className="text-center text-secondary">No transactions found.</p>
          ) : (
            months.map(([month, data]) => {
              const totalCredit = Number(data.total_credit) || 0;
              const totalDebit = Number(data.total_debit) || 0;
              const txs = Array.isArray(data.transactions)
                ? data.transactions
                : [];

              return (
                <div key={month} className="mb-4 border-bottom pb-3">
                  <div className="d-flex justify-content-between align-items-center mb-3 transaction-head">
                    <h6 className="fw-semibold text-theme mb-0">{month}</h6>
                    <div className="text-muted small transaction-details">
                      <span className="me-3">
                        <strong>Credit:</strong> ₹{formatAmount(totalCredit)}
                      </span>
                      <span>
                        <strong>Debit:</strong> ₹{formatAmount(totalDebit)}
                      </span>
                    </div>
                  </div>

                  {txs.map((tx) => {
                    const amt = Number(tx.amount) || 0;
                    const isCredit = tx.type === "credit";
                    const amountText = `${isCredit ? "+" : "-"}₹${formatAmount(
                      amt
                    )}`;
                    const dateText = tx.date || tx.created_at || "—";

                    return (
                      <div
                        key={tx.id}
                        className="d-flex justify-content-between align-items-center p-3 mb-3 transaction-item"
                      >
                        <div className="transaction-item-left">
                          <div className={`transaction-icon ${isCredit ? 'text-success bg-success' : 'text-danger bg-danger'}`}>
                            {isCredit ? <ArrowDown /> : <ArrowUp />}
                          </div>
                          <div>
                            <p className="fw-medium mb-1 text-dark">
                              {isCredit ? "Credit" : "Debit"}
                            </p>
                            <p className="small text-muted mb-0">
                              {tx.description || "No description"}
                            </p>
                          </div>
                        </div>
                        <div className="text-end">
                          <p
                            className={`fw-semibold mb-1 ${isCredit ? "text-success" : "text-danger"
                              }`}
                          >
                            {amountText}
                          </p>
                          <p className="text-muted small mb-0">{dateText}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })
          )}
      </div>
    </div>
  );
};

export default TransactionHistory;
